// Design System — InlineAddSelect constants
export const INLINE_ADD_SELECT_ICON = { ADD: 'icon-svg-plus' };
// select2 parity: remote search starts after two typed characters.
export const INLINE_ADD_SELECT_MIN_INPUT_LENGTH = 2;
export const INLINE_ADD_SELECT_KEY = { ESCAPE: 'Escape' };
